import { getChargebacksCsv } from '@/concepts/Earnings/repository/getChargebacks'
import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'

export const handleChargebacksCsv = async (
  startAt: string,
  endAt: string,
  saleId?: string
) => {
  const csv = await getChargebacksCsv({ saleId, startAt, endAt })

  const url = window.URL.createObjectURL(new Blob([String(csv)]))
  const link = document.createElement('a')
  const fileName = generateCsvFileName(startAt, endAt)

  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const generateCsvFileName = (startAt: string, endAt: string) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return 'chargebacks.csv'

  const name = role.name.replace(/\s+/g, '_').toLowerCase()

  const time =
    startAt && endAt ? `${startAt}-${endAt}` : new Date().toISOString()

  return `${name}_${time}.csv`
}
